import useSWRMutation from 'swr/mutation';
import { changePasswordRequest, type ChangePasswordParams } from '../requests';

export const useChangePasswordMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'change-password-mutation',
    (_, { arg }: { arg: ChangePasswordParams }) => changePasswordRequest(arg),
  );

  return {
    changePassword: trigger,
    isChangingPassword: isMutating,
    changePasswordError: error,
    resetChangePassword: reset,
  };
};
